import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import Text from "../Text/Text";
import { AlignTarget } from "../Align";
var sizeInPx = {
  large: 24,
  medium: 16,
  small: 12
};

var Spinner = /*#__PURE__*/function (_React$Component) {
  _inherits(Spinner, _React$Component);

  var _super = _createSuper(Spinner);

  function Spinner(props) {
    var _this;

    _classCallCheck(this, Spinner);

    _this = _super.call(this, props);
    _this.timeout = void 0;
    _this.state = {
      shown: !props.delay
    };
    return _this;
  }

  _createClass(Spinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var delay = this.props.delay;

      if (delay) {
        this.timeout = setTimeout(function () {
          _this2.setState({
            shown: true
          });
        }, delay);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          color = _this$props.color,
          flex = _this$props.flex,
          size = _this$props.size,
          text = _this$props.text,
          delay = _this$props.delay,
          spinnerProps = _objectWithoutProperties(_this$props, ["children", "className", "color", "flex", "size", "text", "delay"]);

      var shown = this.state.shown;

      if (!shown) {
        return null;
      }

      var spinnerClasses = classNames('Spinner bs-SpinnerLegacy', className, {
        'Spinner--color--white': color === 'white',
        'Spinner--size--large': size === 'large',
        'Spinner--size--small': size === 'small'
      });
      var spinnerTextColorValues = color === 'white' ? 'white' : 'default';
      var spinnerTextSizeValues = size === 'large' ? 16 : 14;
      var spinnerTextLineHeight = 20;
      var spinnerFlexValues = flex ? 'flex' : 'inline-flex';
      var spinnerLineHeight = Math.max(sizeInPx[size], text ? spinnerTextLineHeight : 0);
      return /*#__PURE__*/React.createElement(AlignTarget, _extends({}, spinnerProps, {
        strategy: "center",
        lineHeight: spinnerLineHeight
      }), function (alignProps) {
        return (
          /*#__PURE__*/
          // $FlowFixMe - go/flowfixme122
          React.createElement(Box, _extends({
            flex: {
              alignItems: 'center',
              justifyContent: 'center',
              display: spinnerFlexValues
            },
            className: spinnerClasses
          }, spinnerProps, alignProps), /*#__PURE__*/React.createElement("svg", {
            viewBox: "0 0 24 24",
            className: "Spinner-svg"
          }, /*#__PURE__*/React.createElement("g", {
            transform: "translate(1 1)",
            fillRule: "nonzero",
            fill: "none"
          }, /*#__PURE__*/React.createElement("circle", {
            cx: "11",
            cy: "11",
            r: "11"
          }), /*#__PURE__*/React.createElement("path", {
            d: "M10.998 22a.846.846 0 0 1 0-1.692 9.308 9.308 0 0 0 0-18.616 9.286 9.286 0 0 0-7.205 3.416.846.846 0 1 1-1.31-1.072A10.978 10.978 0 0 1 10.998 0c6.075 0 11 4.925 11 11s-4.925 11-11 11z",
            fill: "currentColor"
          }))), text && /*#__PURE__*/React.createElement(Box, {
            margin: {
              left: 8
            }
          }, /*#__PURE__*/React.createElement(Text, {
            color: spinnerTextColorValues,
            lineHeight: spinnerTextLineHeight,
            size: spinnerTextSizeValues,
            weight: "regular"
          }, text)), children)
        );
      });
    }
  }]);

  return Spinner;
}(React.Component);

Spinner.defaultProps = {
  color: 'regular',
  size: 'medium'
};
export default Spinner;